import { Fragment } from "react";
import { TabPane } from "reactstrap";
import { LI, UL } from "../../../../../AbstractElements";
import { useAppSelector } from "../../../../../ReduxToolkit/Hooks";
import SearchNotFoundClass from "../../../../CommonComponents/SearchNotFound/SearchNotFoundClass";
import InboxEmailContent from "../InboxContent/InboxEmailContent";

const StarredContent = () => {
  const { inboxEmail } = useAppSelector((state) => state.letterBox);
  let starBadges = inboxEmail.filter((data) => data.star === true && 1);

  return (
    <TabPane tabId="3">
      <div className="mail-body-wrapper">
        <UL className="simple-list">
          {starBadges.length > 0 ? (
            inboxEmail.map((data, i) => (
              <Fragment key={i}>
                {data.star && (
                  <LI className="inbox-data">
                    <InboxEmailContent data={data} ids={i} />
                  </LI>
                )}
              </Fragment>
            ))
          ) : (
            <SearchNotFoundClass word="Email" />
          )}
        </UL>
      </div>
    </TabPane>
  );
};

export default StarredContent;
